
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buying-guides/detail",
      function () {
        return require("private-next-pages/buying-guides/detail.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buying-guides/detail"])
      });
    }
  